import { MidpointRoundingType } from 'Lib/Round';
import { FormatTypes } from '.';

/**
 * Date and time data formats used on QEST Web API models
 */
export enum DateTimeDataFormat {
  /**
   * Local date, with no time component
   */
  Date,
  /**
   * Local time, with no date component
   */
  Time,
  /**
   * Local date and time, with no time zone indication.
   * Typically this is a local date and time in the laboratory's timezone.
   */
  UnspecifiedLocalDateTime,
}

export type FormatSpecifier = {
  /**
   * The type of formatting applied
   * Taken as FixedPoint by default
   */
  type?: FormatTypes;
  /**
   * Midpoint rounding to use when rounding numeric values for formatting
   * Taken as "to even" by default
   */
  midpoint?: MidpointRoundingType;
  /**
   * For the fixed point format type, this sets the rounding interval.
   * Ignored for other format types
   */
  nearest?: number;
  /**
   * For the significant figures format type, this sets the number of significant figures
   * For the fixed point format type, this is the number of decimal places shown. Will be ignored if nearest has a value.
   * Ignored for other format types
   */
  precision?: number;
  /**
   * For date/time format types, this is the pattern used to format the date/time.
   * This pattern is passed to the moment library to format the date/time
   * Moment formats are described at https://momentjs.com/docs/#/parsing/string/
   *
   * If you do not specify a format, the default format used depends on the format
   * type:
   * * Date: `'DD-MMM-YYYY'`
   * * Time: `'HH:mm'`
   * * DateTime: `'DD-MMM-YYYY HH:mm'`
   */
  pattern?: string;
};
